export const parseRange = (text) => {
  const match = text?.match(/from\s+(\d+)(?:\s+to\s+(\d+))?/i);
  if (!match) return null;
  const from = parseInt(match[1], 10);
  const to = match[2] ? parseInt(match[2], 10) : Infinity;
  return { from, to };
};

export const calculateUnitPrice = (item) => {
  const quantity = item.quantity;
  const priceR = Number(item.price_r) || 0;
  const priceW = Number(item.price_w) || 0;
  const priceO = item.price_w_add ? Number(item.price_w_add) : null;

  const wholesaleRange = parseRange(item.w_amount);
  const wholesaleAddRange = item.w_amount_add && item.w_amount_add.trim() !== '' && parseRange(item.w_amount_add);
  let unitPrice = priceR;
  let prevPrice = priceR;

  // 👇 Adjust logic here
  if (priceO !== null && wholesaleAddRange && quantity >= wholesaleAddRange.from) {
    // If price_o exists and quantity is in or above the add range → apply price_o
    prevPrice = priceW;
    unitPrice = priceO;
  } else if (wholesaleRange && quantity >= wholesaleRange.from) {
    // If price_o doesn't exist → apply wholesale price to all quantities >= wholesale range
    prevPrice = priceR;
    unitPrice = priceW;
  }

  return {
    unitPrice,
    prevPrice,
    totalPrice: unitPrice * quantity
  };
};

export const getCurrencySymbol = (region, price) => {
  if (typeof price === 'string' && price.includes('You can')) {
    return '';
  }
  switch (region) {
    case 'gb':
      return '£';
    case 'cn':
      return '¥';
    default:
      return '$';
  }
};
